import { render, staticRenderFns } from "./selectApp.vue?vue&type=template&id=0049031b&scoped=true&"
import script from "./selectApp.vue?vue&type=script&lang=js&"
export * from "./selectApp.vue?vue&type=script&lang=js&"
import style0 from "./selectApp.vue?vue&type=style&index=0&id=0049031b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0049031b",
  null
  
)

export default component.exports